module.exports = __webpack_public_path__ + "img/grain-logotype-white.e31d628e.png";